import { leafletDefaults } from '@/constants/leaflet'
import { LCircleMarker, LControlZoom, LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import { mapActions, mapGetters } from 'vuex'
import 'leaflet.tilelayer.pouchdbcached'
import L from 'leaflet'
import PouchDB from 'pouchdb'

export default {
  components: {
    LCircleMarker,
    LControlZoom,
    LMap,
    LTileLayer,
    LMarker,
  },

  props: {
    strollId: {
      type: [Number, String],
      default: null,
    }
  },

  methods: {
    ...mapActions([
      'fetchStroll',
    ]),
    async retrieveStroll() {
      this.stroll = await this.fetchStroll({id: this.strollId})
      this.center = this.stroll.point.coordinates
    },
  },

  computed: {
    ...mapGetters({
      location: 'getLocation',
      strolls: 'getStrolls',
      getStrollById: 'getStrollById',
    }),
  },

  data () {
    return {
      ...leafletDefaults,
      stroll: null,
      zoom: 15,
      center: L.latLng(45.3157247, -64.4338494),
      mapOptions: { zoomControl: false },
    }
  },

  watch: {
    // call again the method if the route changes
    '$route': function() {
      this.retrieveStroll()
    }
  },

  async created() {
    if (window !== undefined) {
      window.PouchDB = PouchDB
    }

    await this.retrieveStroll()
  },
}
